import { render, staticRenderFns } from "./Unsubscriptions.vue?vue&type=template&id=453a1b04&scoped=true&"
import script from "./Unsubscriptions.vue?vue&type=script&lang=js&"
export * from "./Unsubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=453a1b04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a1b04",
  null
  
)

export default component.exports